import { Paper, Fade, PaperProps, styled } from '@mui/material';
import { ContentIslandHeader } from './ContentIslandHeader';

export type ContentIslandOwnProps = {
  title?: React.ReactNode;
  actions?: React.ReactNode;
};

export type ContentIslandProps = PaperProps<'div', ContentIslandOwnProps>;

const ContentIslandRoot = styled(Paper, {
  name: 'ContentIsland',
  slot: 'root',
})({
  width: '100%',
  height: 'fit-content',
});

export function ContentIsland({ title, actions, children, ...props }: ContentIslandProps) {
  return (
    <Fade in>
      <ContentIslandRoot {...props}>
        {title || actions ? <ContentIslandHeader title={title} actions={actions} /> : null}
        {children}
      </ContentIslandRoot>
    </Fade>
  );
}
